import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import PrivateRoute from "./routes/PrivateRoute";

const App = () => {
  return (
    <Fragment>
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              route.private ? (
                <PrivateRoute>{route.element}</PrivateRoute>
              ) : (
                route.element
              )
            }
          />
        ))}
      </Routes>
    </Fragment>
  );
};

export default App;
